import moment from "moment";
moment.locale("es-mx");
const FormatDate = ({ dateAdd, Fecha }: any) => {
  const dateFormat = moment.utc(dateAdd).format("L");
  return <span>{dateAdd ? dateFormat : ""}</span>;
};

export default FormatDate;